module.exports = __webpack_public_path__ + "46b235a30c507ea29cf464f3dae87856.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-sunset.png
// module id = 1850
// module chunks = 0